var scope_0 = require('/Users/yennytjan/Documents/_works/Gatsby_Crystal_Choir/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0065fb23e4d353f8f5b8186cb09bd017.js').default;
var scope_1 = require('/Users/yennytjan/Documents/_works/Gatsby_Crystal_Choir/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/02d513165c30b1d922fa38404b0c7eb6.js').default;
var scope_2 = require('/Users/yennytjan/Documents/_works/Gatsby_Crystal_Choir/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/24495ad6bda3aa180b5136bbaddd396a.js').default;
var scope_3 = require('/Users/yennytjan/Documents/_works/Gatsby_Crystal_Choir/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    